exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#frmReport[data-v-ba475bb4] {\n  width: 100% ;\n  /*min-width: 100%;*/\n  /*border: 0px;*/\n  height: calc(100% - 3px);\n  /*max-height: 100vh;*/\n  /*min-height: 90vh;*/\n  overflow: hidden;\n  margin-top: 0px;\n  margin-left: 8px;\n}\n", ""]);

// exports
